import React from "react";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../assets/leftArrow.svg";
import Card from "../../components/_edit_profile/Card/Card";
import { PATHS } from "../../routes/paths";
import Layout from "../../shared/Layout/Layout";
import styles from "./EditProfile.module.scss";

const EditProfile = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div
            className={styles.leftArrow}
            onClick={() => navigate(PATHS.settings)}
          >
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Edit profile</h1>
          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default EditProfile;
